import { marquageTunnel } from './marquage.js';
(function ($) {
  $(document).ready(function () {


    var url = window.location.href;

    if (url == "https://panaget-preprod.dpk-blx-cl01.agoracalyce.net/tunnel-de-devis/") {
    }

    setCookie('rooms', []);
    setCookie('tunnel-devis', []);

    var acc = document.getElementsByClassName("accordion");
    var i;
    var currentPage = 2;
    var postType = seize_data.postType
    let filter_terms = []


    if (document.getElementById('list-whishlist')) {
      let currentWishlist = JSON.parse(document.getElementById('list-whishlist').value || '[]');
      console.log(currentWishlist)
      let newWishlistCount = $('.favorite-products__list-single').length;

      if (currentWishlist.length !== newWishlistCount) {
        let wishlistItems = [];
        $('.favorite-products__list-single').each(function () {

          let surfaceVal = $(this).find('.favorite-products__list-surface input').val()
          let item = {
            id: $(this).attr('data-id'),
            unit: surfaceVal ?? '', // Ensure surfaceValue is defined
            multiref: $(this).attr('data-multi'),
            libelle: $(this).attr('data-libelle')
          };
          wishlistItems.push(item);

        })
        setTimeout(() => {
          document.getElementById('list-whishlist').value = JSON.stringify(wishlistItems);
        }, 2000);

      }

    }


    $('.header-main .menu-item-has-children').hover(
      function () {
        $('.sub-menu-wrapper').removeClass('active')
        $(this).find('.sub-menu-wrapper').addClass('active')
      }, function () {
      }
    )
    $('.header-main__menu > .menu-menu-principal-fr-container > .menu > .menu-item').hover(
      function () {
        if (!$(this).hasClass("menu-item-has-children")) {
          $('.sub-menu-wrapper').removeClass('active')

        }
      }
    );
    $(".header-main .sub-menu-wrapper").on('mouseleave', function () {

      $(this).removeClass('active')
    })

    $('.hamburger').on('click', function () {
      $(this).toggleClass('active')
      $(' .header-mobile__col').toggleClass('active')
      $('.header-mobile__inner').toggleClass('active')
    })

    $('.header-mobile__inner-menu__child').on('click', function (e) {
      e.preventDefault();

      let child_mobile = $(this).attr('data-menu')

      $('.mobile-child__menu').each(function () {
        if ($(this).attr('data-menu') !== child_mobile) {
          $(this).removeClass('active');
        }
      });
      $('.mobile-child__menu[data-menu="' + child_mobile + '"]').addClass('active');
    })
    $('.mobile-child__menu-back').on('click', function () {
      $('.mobile-child__menu').removeClass('active')
    })
    // $('.menu-item-has-children').on('click', function () {
    //   $(this).toggleClass('active')
    // })

    // $(".sub-menu").hover(
    //   function () {
    //     console.log('hover')
    //   },
    //   function () {
    //     console.log('fini')
    //     $('.sub-menu').removeClass('active');
    //   }
    // );

    $('.home-scroll').on('click', function () {

      $('html, body').animate({
        scrollTop: $('.text-center').offset().top
      }, 500);
    })

    $('.single-description__img-slick').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      // Remove the 'active-slide' class from all slides
      $('.slick-slide').removeClass('active-slide');
    });

    $('.single-description__img-slick').on('afterChange', function (event, slick, currentSlide) {
      // Add the 'active-slide' class to the current slide
      $('.slick-slide').eq(currentSlide + 1).addClass('active-slide');
    });

    $('.single-description__img-slick').on('click', '.slick-active .single-description__img__full', function () {

      // Open the modal only if the click event is triggered by clicking the image
      $('.modal-ambiant').addClass('active');

    })

    $('.modal-close').on('click', function () {
      $('.modal-ambiant').removeClass('active');
    })

    $('.archive-content__ul .archive-content__ul-li').on('click', function () {
      if ($(this).attr('data-tax') != "all") {
        $('.archive-content__ul li[data-tax="all"]').removeClass('active')
      } else {
        $('.archive-content__ul li').removeClass('active')
      }
      $(this).toggleClass('active')
      let filter = [];
      $('.archive-content__ul li.active').each(function () {
        filter.push($(this).attr('data-tax'))

      })


      let postType = $(this).attr('data-post')
      let lang = $('html')[0].lang
      var dataToSend = {
        filters: filter, // Assuming 'filter' is your array data
        postType: postType,
        lang: lang
      };

      let seize_rest = seize_data.site_url + '/wp-json/panaget/v1'

      $.ajax({
        url: seize_rest + '/conseilsFilter',
        dataType: "json",
        type: 'POST',
        data: dataToSend,
        success: function (response) {
          $('.archive-content__post .row').html(response)
        }
      })










      // $('.archive-content__ul li').removeClass('active')

      // let dataConseils = $(this).attr('data-tax')
      // if (dataConseils == "all") {
      //   $('.archive-content__post-col').show()

      // } else {
      //   $('.archive-content__post-col').hide()
      //   $('.archive-content__post-col[data-slug="' + dataConseils + '"]').show()

      // }
    })

    $('.filter-title').on('click', function () {
      $(this).toggleClass('active')
      $(this).siblings('.filter-accordion[data-accordion="' + $(this).attr('data-button') + '"]').toggleClass('active')
    })
    $('.filter-accordion__inner-title').on('click', function () {
      $(this).toggleClass('active')
      $('.filter-accordion__sub[data-subteinte="' + $(this).attr('data-teinte') + '"').toggleClass('active')
    })






    $('.filter-input').on('click', function () {

      $('.listing-products__filter').addClass('loader')
      $(this).toggleClass('active')
      let taxonomy = $(this).closest('.filter-accordion__tax').attr('data-accordion')
      let value = $(this).attr('data-value')
      let postType = $('.listing-products').attr('data-posttype')
      $('.loader-estimate').addClass('active')

      if (taxonomy == "type_de_parquet") {
        $(this).siblings('.filter-input').removeClass('active')
      }

      let existingTermIndex = filter_terms.findIndex(term => term.taxonomy === taxonomy);


      var activeFilterCount = $('.filter-input.active').length

      if (activeFilterCount > 0) {
        $('.listing-products__filter_remove').addClass('active')
      }
      if ($(this).hasClass('active')) {
        // If the term is selected, add it to the array
        if (existingTermIndex !== -1) {


          if (taxonomy == "type_de_parquet") {
            filter_terms[existingTermIndex].values = []
          }
          // If the term already exists, add the value only if it doesn't exist
          if (!filter_terms[existingTermIndex].values.includes(value)) {
            filter_terms[existingTermIndex].values.push(value);
          }
        } else {
          // If the term doesn't exist, add it to the array with the value
          filter_terms.push({ taxonomy, values: [value] });
        }
      } else {
        // If the term is deselected, remove the value from the array
        if (existingTermIndex !== -1) {
          let valueIndex = filter_terms[existingTermIndex].values.indexOf(value);
          if (valueIndex !== -1) {
            filter_terms[existingTermIndex].values.splice(valueIndex, 1);
          }

          // If there are no values left for the term, remove the term from the array
          if (filter_terms[existingTermIndex].values.length === 0) {
            filter_terms.splice(existingTermIndex, 1);
          }
        }
      }



      currentPage = 1
      $.ajax({
        type: 'POST',
        url: seize_data.ajaxUrl,
        data: {
          action: 'retrieve_products_listing', // Add the appropriate action hook for WordPress
          selected_terms: filter_terms,
          post_type: postType,
          page: 1,
          post_id: seize_data.post_id
        },
        dataType: 'json',
        success: function (response) {

          $('.listing-product__list').html(response.template_output);

          if (response.category_text != "" || response.category_title) {
            $('.listing-products__inner-content-title h1').html(response.category_title)
            $('.listing-products__inner-content-paragraph').html(response.category_text)
            $("html, body").animate({ scrollTop: 0 }, 600);
          }
          if (response.max_pages == currentPage) {
            $('.listing-products__load').hide()
          } else if (response.max_pages > 1 || response.max_pages > currentPage) {
            currentPage++;
            $('.listing-products__load').show()
          }
          // console.log(response);
          $('.listing-products__filter').removeClass('loader')
          $('.loader-estimate').removeClass('active')
        },
        error: function (error) {
          // Handle the error response
          console.error(error);
        },
      });


    })

    $(document).on('click', '.pagination-link', function (e) {
      e.preventDefault();
      $('.loader-estimate').addClass('active')
      var page = $(this).data('page');
      var category = $('.filter-btn.active').data('category');

      $.ajax({
        url: seize_data.ajaxUrl,
        type: 'POST',
        data: {
          action: 'filter_products',
          category: category || 'all',
          paged: page
        },
        success: function (response) {

          $('.woocommerce-loop__inner').html(response.products);
          $('#listPagination').replaceWith(response.pagination); // or appendTo if not in DOM yet
          $('.loader-estimate').removeClass('active')
          // Important : Re-bind les événements si pagination réinsérée
        }
      });
    });







    $('.filter-btn').click(function () {
      $('.loader-estimate').addClass('active')
      $('.filter-btn').removeClass('active')
      $(this).addClass('active')
      var category = $(this).data('category');
      if (category == "finitions" || category == "finishing" || category == "abschluss") {
        $('.archive-product__button-finition').addClass('active')
      } else {
        $('.archive-product__button-finition').removeClass('active')
      }
      $.ajax({
        url: seize_data.ajaxUrl,
        type: 'POST',
        data: {
          action: 'filter_products',
          category: category,
          paged: 1
        },
        success: function (response) {
          console.log(response.html)
          $('.woocommerce-loop__inner').html(response.products);
          $('#listPagination').replaceWith(response.pagination); // or appendTo if not in DOM yet
          $('.loader-estimate').removeClass('active')

        }
      });
    });

    $('.filter-btn__finition').click(function () {
      $('.loader-estimate').addClass('active')
      $('.filter-btn__finition').removeClass('active')
      $(this).addClass('active')
      var finition = $(this).data('finition');
      $.ajax({
        url: seize_data.ajaxUrl,
        type: 'POST',
        data: {
          action: 'filter_products_finition',
          finition: finition
        },
        success: function (response) {
          $('.woocommerce-loop__inner').html(response);
          $('.loader-estimate').removeClass('active')
        }
      });
    })



    $('.filter-all').click(function () {
      console.log('Filtrer'); // Log that the filter was triggered
      let filterAll = $(this);
      let targetClass = filterAll.hasClass('able') ? 'disable' : 'able'; // Determine the class to show

      filterAll.hide(); // Hide the clicked element
      filterAll.siblings(`.${targetClass}`).show(); // Show the corresponding sibling element

      filterAll.siblings('.filter-accordion__sub-list').children('li').each(function () {
        let isActive = $(this).hasClass('active');
        if ((filterAll.hasClass('able') && !isActive) || (filterAll.hasClass('disable') && isActive)) {
          $(this).click(); // Trigger click based on active state
        }
      });
    });



    $('.listing-products__filter_remove').on('click', function () {
      $(this).removeClass('active')
      let postType = $('.listing-products').attr('data-posttype')
      var activeFilterCount = $('.filter-input.active')
      if (activeFilterCount.length > 0) {
        activeFilterCount.each(function () {
          $(this).removeClass('active')
        })
      }
      filter_terms = []
      currentPage = 1
      $.ajax({
        type: 'POST',
        url: seize_data.ajaxUrl, // Assuming ajaxurl is defined in your WordPress environment
        data: {
          action: 'retrieve_products_listing', // Add the appropriate action hook for WordPress
          selected_terms: [],
          post_type: postType,
          page: currentPage,
        },
        success: function (response) {

          $('.listing-product__list').html(response.template_output);
          if (response.max_pages > 1) {
            console.log('ui')
            $('.listing-products__load').show()
          } else {
            $('.listing-products__load').hide()

          }
          // console.log(response);
        },
        error: function (error) {
          // Handle the error response
          console.error(error);
        },
      });
    })

    $('.toggle-filters').on('click', function () {
      $('.listing-products__filter').toggleClass('active')
    })
    $('.listing-products__filter-close').on('click', function () {
      $('.listing-products__filter').toggleClass('active')
    })






    var $status = $('.estimate-tunnel__pages');



    $('.post-thumbnail__row-slick').slick({
      slidesToShow: 3,
      dots: false,
      infinite: true,
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,

          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,

          }
        }
      ]

    })
    // Use afterChange event to update button state
    // $('button.slick-next.slick-arrow').addClass("btn-disabled");
    $('button.slick-next.slick-arrow').attr('btn-title', $('.slick-current').attr('title'))







    $('.slick-next').on('click', function (e) {

    })

    $('.single-description__img-slick').slick({
      dots: false,
      arrows: false,
      asNavFor: '.single-description__img-slick-thumbnail, .single-description__img-slick-zoom',
      slidesToScroll: 1,
      infinite: true
    })

    $('.single-description__img-slick-thumbnail').slick({
      asNavFor: '.single-description__img-slick, .single-description__img-slick-zoom',
      slidesToShow: 4,
      slidesToScroll: 0,
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      arrows: true,
      prevArrow: $('.slick-prev'),
      nextArrow: $('.slick-next'),
    })

    $('.single-description__img-slick-zoom').slick({
      dots: false,
      arrows: true,
      slidesToScroll: 1,
      infinite: true,
      prevArrow: $('.slick-prev-zoom'),
      nextArrow: $('.slick-next-zoom'),
    })




    $(document).on("click", ".estimate-tunnel__slide-right__input-colors", function () {
      //   console.log(e.target)
      //   if ($('.input-change-surface').is(e.target) || $('.btn-add-surface').is(e.target)){
      //     e.stopPropagation();
      //     e.preventDefault();
      //     return;
      //   }
      $('.estimate-tunnel__slide-right__colors .estimate-tunnel__slide-right__input-style').removeClass('active')
      $('.estimate-tunnel__slide-right__colors-sub').removeClass('active')

      if ($(this).hasClass('active')) {
        $(this).removeClass('active')
      } else {
        $(this).addClass('active')
      }

      let cat_color = $(this).data('cat')
      $(this).parent('.estimate-tunnel__slide-right__colors').siblings('.estimate-tunnel__slide-right__colors-container').children('.estimate-tunnel__slide-right__colors-sub[data-parent="' + cat_color + '"]').addClass('active')

    })


    $('.estimate-tunnel__slide-right__colors-sub__single').on('click', function () {
      // $(this).siblings().removeClass('active')

      if ($(this).hasClass('active')) {
        $(this).removeClass('active')
      } else {
        $(this).addClass('active')
      }

    })


    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        this.classList.toggle("active");
        /* Toggle between hiding and showing the active panel */
        var panel = this.nextElementSibling;
        if (panel.style.display === "block") {
          panel.style.display = "none";
          panel.style.overflow = "none";
        } else {
          panel.style.display = "block";
          panel.style.overflow = "visible";
        }
      });
    }





    $('.listing-products__load button').on('click', function () {

      $.ajax({
        type: 'POST',
        url: seize_data.ajaxUrl,
        data: {
          action: 'retrieve_products_listing',
          page: currentPage,
          post_type: postType,
          selected_terms: filter_terms,
          posts_per_page: 12,
        },
        success: function (response) {

          $('.listing-product__list').append(response.template_output);
          if (response.max_pages == currentPage) {
            $('.listing-products__load').hide()
          } else if (response.max_pages > 1 || response.max_pages > currentPage) {
            currentPage++;
            $('.listing-products__load').show()
          }


          // console.log(response);
        },
      });
    })
    $(document).on("click", ".listing-product__single-icon", function (e) {

      $(this).toggleClass('active')
      if ($(this).hasClass('active')) {
        $(this).children('span').text('Retirer des favoris')
      } else {
        $(this).children('span').text('Ajouter aux favoris')
      }
      e.preventDefault();
      toggleFavorite($(this).attr('data-id'), $('.whishlist-multi').val(), $(this).attr('data-surface'))

      let numberOfFavorites = getFavoriteProducts()
      $('.header-main__right-icons-heart a span').text(numberOfFavorites.length)
    })

    $('.btn-fill__estimate').on('click', function (e) {
      $(this).closest('.favorite-products__list-button').find('.error-message').remove();
      let surfaceInput = $(this).closest('.favorite-products__list-button').siblings('.favorite-products__list-surface').find('input');
      let inputValue = surfaceInput.val();
      if (inputValue == 0 || inputValue === '') {
        e.preventDefault()
        // Append a span with a message if it doesn't already exist
        $(this).closest('.favorite-products__list-button').prepend('<span class="error-message">' + seize_data.error_message + '</span>');
        return
      }
      removeFromEstimate('all')
      let surfaceDiv = $(this).closest('.favorite-products__list-button').siblings('.favorite-products__list-surface')
      let surfaceValue = surfaceDiv.children('input').val()
      // setFavoriteProductsInEstimate({ id: $(this).attr('data-ref'), unit: '25' })
      // document.cookie = 'estimateProducts=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

      toggleEstimate({ id: $(this).attr('data-id'), unit: surfaceValue, multiref: $(this).attr('data-multi'), libelle: $(this).attr('data-libelle') })
    })

    $('.btn-estimate__all').on('click', function (e) {
      $('.error-message').remove();
      $('.favorite-products__list-single').each(function () {
        let surfaceValue = $(this).find('.favorite-products__list-surface').children('input').val()
        if (surfaceValue == 0 || surfaceValue === '') {

          e.preventDefault()
          // Append a span with a message if it doesn't already exist

          $(this).find('.favorite-products__list-button').prepend('<span class="error-message">' + seize_data.error_message + '</span>');
        }
        toggleEstimate({ id: $(this).attr('data-id'), unit: surfaceValue, multiref: $(this).attr('data-multi'), libelle: $(this).attr('data-libelle') })
      })
    })

    $('.surface-input').on('click', function () {
      let surfaceInput = $(this).siblings('input')
      $('.error-message').remove()

      $(this).find('.favorite-products__list-surface').closest('.error-message').remove()
      let currentValue = parseInt(surfaceInput.val()) || 0;
      if ($(this).hasClass('less')) {
        if (currentValue > 0) { // Optional: prevent the value from going below 0
          surfaceInput.val(currentValue - 1);
        }
      } else if ($(this).hasClass('more')) {
        surfaceInput.val(currentValue + 1);
      }
      let surfaceValue = $(this).siblings('input').val()

      let libelleValue = $(this).closest('.favorite-form__list-content__options').siblings('.favorite-form__list-content__title').children('strong').text()
      libelleValue = libelleValue.trimEnd()
      toggleEstimate({ id: $(this).attr('data-id'), libelle: libelleValue, unit: surfaceValue })

    })


    $('#surface-input').on('change', function () {
      let surfaceValue = $(this).val()
      console.log(surfaceValue)

      let link = $('.btn-quote-form'); // Select the link by class
      let url = new URL(link.attr('href')); // Create a URL object
      url.searchParams.set('surface', surfaceValue); // Set the surface parameter
      link.attr('href', url.toString()); // Update the link href with the new URL
    })

    $('.surface-input__single').on('click', function () {
      let surfaceInput = $(this).siblings('input')
      $('.error-message').remove()

      let currentValue = parseInt(surfaceInput.val()) || 0;
      if ($(this).hasClass('less')) {
        if (currentValue > 0) { // Optional: prevent the value from going below 0
          surfaceInput.val(currentValue - 1);
        }
      } else if ($(this).hasClass('more')) {
        surfaceInput.val(currentValue + 1);
      }
      let surfaceValue = $(this).siblings('input').val()
      console.log(surfaceValue)

      let link = $('.btn-quote-form'); // Select the link by class
      let url = new URL(link.attr('href')); // Create a URL object
      url.searchParams.set('surface', surfaceValue); // Set the surface parameter
      link.attr('href', url.toString()); // Update the link href with the new URL
    })
    $('.whishlist-multi').on('change', function () {
      let link = $('.btn-quote-form'); // Select the link by class
      if (link.length) {
        let url = new URL(link.attr('href')); // Create a URL object
        url.searchParams.set('multiref', $(this).val()); // Set the multiref parameter
        link.attr('href', url.toString()); // Update the link href with the new URL
      }
    })

    $('.btn-quote-form').on('click', function (e) {

      let surfaceInput = $('#surface-input');
      let inputValue = surfaceInput.val();
      console.log(inputValue)
      if (inputValue == 0 || inputValue === '') {
        e.preventDefault()
        // Append a span with a message if it doesn't already exist
        $(this).before('<span class="error-message">' + seize_data.error_message + '</span>');
        return
      }
    })

    $('.favorite-products__list-surface .edit').on('click', function () {
      $(this).toggleClass('active')
      $(this).siblings('input').toggleClass('active')
      if ($(this).siblings('input').hasClass('active')) {
        $(this).siblings('input').prop('disabled', false)
      } else {
        $(this).siblings('input').prop('disabled', true)

      }
      let surfaceValue = $(this).siblings('input').val()
      let libelleValue = $(this).closest('.favorite-form__list-content__options').siblings('.favorite-form__list-content__title').children('strong').text()
      libelleValue = libelleValue.trimEnd()
      toggleEstimate({ id: $(this).attr('data-id'), libelle: libelleValue, unit: surfaceValue })
    })

    $('.favorite-products__list-single__delete').on('click', function () {
      let product_ref = $(this).parent('.favorite-products__list-single').attr('data-id')
      removeFromFavorites(product_ref);

      $(this).parent('.favorite-products__list-single').remove()
      let numberOfFavorites = getFavoriteProducts()
      $('.header-main__right-icons-heart a span').text(numberOfFavorites.length)
    })

    $('.favorite-products__page-single__delete').on('click', function () {
      let product_ref = $(this).attr('data-id')

      removeFromEstimate(product_ref);
      $('.favorite-products__list-single[data-id="' + product_ref + '"').remove()
      const dataArray = getEstimateProducts()

      if (document.getElementById('list-whishlist')) {
        document.getElementById('list-whishlist').value = JSON.stringify(dataArray);
      }
    })


    $('.header-pre__drop-btn').on('click', function () {
      $('.header-pre__drop-content').toggleClass('active')
      $('.header-mobile__inner').toggleClass('blur')
    })


  });




  $('.bim-download').on('click', function () {
    let product_bim = $(this).attr('data-ref')
    setCookie('BIM', product_bim, 7);
  })
  if ($('#bim-id')) {
    let bim_value = getCookie('BIM')
    $('#bim-id').val(bim_value)
  }

  /**
  * 
  *  U N I T Y  &  D E V I S E  M A N A G E 
  * 
  */



  $('.devise-manage').on('click', function () {
    $('.devise-manage').removeClass('active')
    $(this).addClass('active')
    setCookie('devise', $(this).attr('data-devise'), 30); // Adjust the options as needed
    location.reload();
  })

  $('.unity-manage').on('click', function () {
    $('.unity-manage').removeClass('active')
    $(this).addClass('active')

    let seize_rest = seize_data.site_url + '/wp-json/panaget/v1'
    $.ajax({
      url: seize_rest + '/setUnity',
      dataType: "json",
      data: {
        'unity': $(this).attr('data-unity')
      },
      type: "POST",
      cache: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
    })
      .done(function (response) {
        location.reload();
      })

  })


  $('.devise-manage').on('click', function () {
    $('.devise-manage').removeClass('active')
    $(this).addClass('active')

    let seize_rest = seize_data.site_url + '/wp-json/panaget/v1'
    $.ajax({
      url: seize_rest + '/setDevise',
      dataType: "json",
      data: {
        'devise': $(this).attr('data-devise')
      },
      type: "POST",
      cache: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
    })
      .done(function (response) {
        location.reload();
      })








    // setCookie('unity', $(this).attr('data-unity'), 30); // Adjust the options as needed
    // location.reload();
  })

  $('.btn-details').on('click', function () {
    let ref = $(this).attr('data-ref')
    $('.favorite-modal').addClass('active')
    $('.favorite-modal__product[data-modal="' + ref + '"]').addClass('active')
  })
  $('.close').on('click', function () {

    $('.favorite-modal').removeClass('active')
    $('.favorite-modal__product').removeClass('active')
  })


  $('#estimateForms').on("click", ".valid_step", function (e) {
    $('.estimate-tunnel__error').removeClass('active')

    let seize_rest = seize_data.site_url + '/wp-json/tunnel/v1'
    e.preventDefault()
    var route = '/estimateForms'
    let back

    if ($(this).hasClass('back')) {
      back = true

    } else {
      back = false
      var isAnyChecked = $('#estimateForms input[type="radio"]:checked, #estimateForms input[type="checkbox"]:checked').length > 0;
      if (!isAnyChecked) {

        $('.estimate-tunnel__error').addClass('active')
        $("html, body").animate({ scrollTop: 0 }, 600);
        return;
      }
    }

    var checkedRooms = $('input[name="rooms"]:checked');
    // Display the values of checked checkboxes
    let rooms = []
    checkedRooms.each(function () {
      let cpt = 1
      let roomType = $(this).val();
      let innerRoom = []; // Initialize a new innerRoom array for each room type
      var surface = $(this).closest('.estimate-tunnel__rooms').find('.tunnel-products__list-surface input');
      surface.each(function () {
        innerRoom.push({
          room: roomType + '_' + cpt,
          surface: $(this).val()
        });
        cpt = cpt + 1
      });
      rooms.push({
        roomType: roomType,
        list: innerRoom
      });
    });

    $('input[name="roomsArray"]').val(JSON.stringify(rooms))
    var formData = new FormData(document.getElementById("estimateForms"));
    formData.append('back', back);
    let titleStep = $('.estimate-tunnel__slide-left__title h2').text()
    $('.loader-estimate').addClass('active')
    $.ajax({
      url: seize_rest + '/estimateForms',
      dataType: "json",
      data: formData,
      type: "POST",
      processData: false,
      contentType: false, //"application/json",
      cache: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
    })
      .done(function (response) {
        if (response) {
          $.ajax({
            url: seize_rest + '/estimateTemplate',
            dataType: "json",
            data: formData,
            type: "POST",
            processData: false,
            contentType: false, //"application/json",
            cache: false,
            crossDomain: true,
            xhrFields: {
              withCredentials: true
            },
          })
            .done(function (response) {
              $('.loader-estimate').removeClass('active')

              if ($('input[name="formid"]').val() == "form-money") {
                if (!back) {
                  marquageTunnel(formData, titleStep, response[0].form_cookie);
                  window.location.href = seize_data.finalisation_url;
                } else {
                  $('#tunnel-dynamic').html(response[0].html)
                  $('.estimate-tunnel_list-steps li').removeClass('active')
                  $('.estimate-tunnel_list-steps li[data-step="' + response[0].step + '"').addClass('active')
                  $('.estimate-tunnel_list-steps li[data-step="' + response[0].step + '"').prevAll().addClass('active')
                  $("html, body").animate({ scrollTop: 0 }, "slow");

                }
              } else {
                if (!back) {
                  marquageTunnel(formData, titleStep)
                }
                if (response[0].step == "redirect") {
                  return window.location.href = response[0].html;
                }
                $('#tunnel-dynamic').html(response[0].html)
                $('.estimate-tunnel_list-steps li').removeClass('active')
                $('.estimate-tunnel_list-steps li[data-step="' + response[0].step + '"').addClass('active')
                $('.estimate-tunnel_list-steps li[data-step="' + response[0].step + '"').prevAll().addClass('active')
                $("html, body").animate({ scrollTop: 0 }, "slow");
              }
            })

        }
      })
  })





  /**
   * 
   *  W H I S L I S T   F O R M
   * 
   */
  // Get the cookie value


  // Parse the JSON data



  const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith('estimateProducts='));

  if (cookieValue) {
    const estimateProductsValue = cookieValue.split('=')[1];

    const dataArray = getEstimateProducts()

    console.log(document.getElementById('list-whishlist'))

    if (document.getElementById('list-whishlist')) {
      if (dataArray.length > 0) {


        setTimeout(() => {
          $('#list-whishlist').val(estimateProductsValue)

        }, 2000);


      } else {


        $('.favorite-products__list-single').each(function () {
          let surfaceValue = $(this).find('.favorite-products__list-surface').children('input').val()

          toggleEstimate({ id: $(this).attr('data-id'), unit: surfaceValue, multiref: $(this).attr('data-multi'), libelle: $(this).attr('data-libelle') })
        })
        document.getElementById('list-whishlist').value = JSON.stringify(getEstimateProducts());


      }
    }

  }


  /**
   * 
   *  C O O K I E S   F U N C T I O N 
   * 
   */
  function getFavoriteProducts() {
    // Get the JSON string from the cookie
    var productsJson = getCookie('favoriteProducts');

    // If the cookie exists, parse the JSON string to get the array
    if (productsJson) {

      return JSON.parse(productsJson);
    } else {
      return [];
    }
  }
  function setCookie(name, value, days) {
    var expires = "";

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";

  }
  function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }



  function addOrUpdateColorsDiv() {
    var cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('rooms='))
      .split('=')[1];

    var roomArray = JSON.parse(cookieValue);


    // Check if the array is not empty
    if (roomArray && roomArray.length > 0) {
      $('.color-clone:not(:first)').remove()
      $.each(roomArray, function (index, room) {
        var clonedDiv = $('.color-clone:first').clone(true);
        // Add text based on the value "room" inside the array element
        clonedDiv.find('span').text(room.room.replace('_', ' '))
        clonedDiv.attr('data-roomColors', room.room)

        // Append the cloned div to the body or any other container
        $('.color-clone__container').append(clonedDiv);
      });

    }
  }
  function addOrUpdateFormatDiv() {
    var cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('rooms='))
      .split('=')[1];
    var roomArray = JSON.parse(cookieValue);

    // Check if the array is not empty
    if (roomArray && roomArray.length > 0) {
      $('.format-clone:not(:first)').remove()
      // Loop through each element in the array
      $.each(roomArray, function (index, room) {
        // Clone the original div

        var clonedDiv = $('.format-clone:first').clone(true);
        // Add text based on the value "room" inside the array element
        clonedDiv.find('span').text(room.room.replace('_', ' '))
        clonedDiv.attr('data-roomFormat', room.room)

        // Append the cloned div to the body or any other container
        $('.format-clone__container').append(clonedDiv);
      });
    }
  }
  function addOrUpdateWidthDiv() {
    var cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('rooms='))
      .split('=')[1];
    var roomArray = JSON.parse(cookieValue);

    // Check if the array is not empty
    if (roomArray && roomArray.length > 0) {
      $('.width-clone:not(:first)').remove()
      // Loop through each element in the array
      $.each(roomArray, function (index, room) {
        // Clone the original div
        var clonedDiv = $('.width-clone:first').clone(true);
        // Add text based on the value "room" inside the array element
        clonedDiv.find('span').text(room.room.replace('_', ' '))
        clonedDiv.attr('data-roomWidth', room.room)

        // Append the cloned div to the body or any other container
        $('.width-clone__container').append(clonedDiv);
      });
    }
  }
  function addOrUpdateAspectDiv() {
    var cookieValue = document.cookie
      .split('; ')
      .find(row => row.startsWith('rooms='))
      .split('=')[1];
    var roomArray = JSON.parse(cookieValue);

    // Check if the array is not empty
    if (roomArray && roomArray.length > 0) {
      $('.aspect-clone:not(:first)').remove()
      // Loop through each element in the array
      $.each(roomArray, function (index, room) {
        // Clone the original div
        var clonedDiv = $('.aspect-clone:first').clone(true);
        // Add text based on the value "room" inside the array element
        clonedDiv.find('span').text(room.room.replace('_', ' '))
        clonedDiv.attr('data-roomAspect', room.room)

        // Append the cloned div to the body or any other container
        $('.aspect-clone__container').append(clonedDiv);
      });
    }
  }



  function addOrUpdateRoom(roomType, surface, updateDiv) {
    const existingRooms = getCookie('rooms');
    const newRoom = { 'room': roomType, 'value': surface };

    let roomsArray = existingRooms ? JSON.parse(existingRooms) : [];
    const roomIndex = roomsArray.findIndex(room => room.room === roomType);


    if (roomIndex !== -1) {
      // Room exists, update its surface
      roomsArray[roomIndex].value = surface;
    } else {
      // Room doesn't exist, add it to the array
      roomsArray.push(newRoom);
    }

    setCookie('rooms', JSON.stringify(roomsArray), 30); // Update the 'rooms' cookie
    if (updateDiv) {
      addOrUpdateColorsDiv();
      addOrUpdateFormatDiv();
      addOrUpdateWidthDiv()
      addOrUpdateAspectDiv();
    }
  }





  function addOrUpdateColor(roomType, color) {
    const existingColors = getCookie('colors');
    const newRoom = { 'room': roomType, 'value': color };

    let colorsArray = existingColors ? JSON.parse(existingColors) : [];
    const colorIndex = colorsArray.findIndex(room => room.room === roomType);

    if (colorIndex !== -1) {
      // Room exists, update its surface
      colorsArray[colorIndex].value += ',' + color;
    } else {
      // Room doesn't exist, add it to the array
      colorsArray.push(newRoom);
    }
    ajaxCallDevis('collection', color)
    setCookie('colors', JSON.stringify(colorsArray), 30); // Update the 'rooms' cookie
  }






  var taxonomy_list = []
  function ajaxCallDevis(taxonomy, color) {

    if (taxonomy == "width") {
      taxonomy = "largeur"
    }
    var colorObject = taxonomy_list.find(item => taxonomy in item);

    if (colorObject) {
      // If the 'color' object exists, update the 'color' property with new values
      colorObject[taxonomy] += ',' + color;
    } else {
      // If the 'color' object doesn't exist, create it and push it to the array
      var newObject = {};
      newObject[taxonomy] = color;
      taxonomy_list.push(newObject);
    }


    let postType = $('.estimate-tunnel__slide-right-posttype').attr('data-info')



  }
  $('#estimateForms').on("click", ".ajax-update__input", function (e) {
    let input = $(this)
    let value = $(this).val()
    $('button.valid_step').addClass('btn-disabled')


    let valuesArray = [];

    let checkedInput = $(this).closest('.estimate-ajax-container').find('input:checked')

    checkedInput.each(function () {
      let value = $(this).val();

      // Concatenate the value to the string, separated by a comma
      valuesArray.push(value);

    })

    if (value == "boismural" || value == "parquet" || value == "wallpanelling") {

    } else {
      if (checkedInput) {
        value = valuesArray
      }
    }




    if ($(this).is(':checked')) {

    }
    let type = $(this).attr('data-info')
    let formId = $('input[name="formid"]').val()
    let dataToSend = {
      type: type,
      value: value,
      formId: formId
    };


    let seize_rest = seize_data.site_url + '/wp-json/tunnel/v1'
    $.ajax({
      url: seize_rest + '/estimateProductsCount',
      dataType: "json",
      type: 'POST',
      data: dataToSend,
      success: function (response) {
        $('button.valid_step').removeClass('btn-disabled')

        let innerCount, plurial
        if (formId == "form-post-type") {
          innerCount = input.closest('.ajax-update').siblings('.estimate-tunnel__slide-right__products').children('p').children('.estimate-tunnel__slide-right__products-span')

        } else {
          innerCount = input.closest('.ajax-update').children('.estimate-tunnel__slide-right__products').children('p').children('.estimate-tunnel__slide-right__products-span')
          plurial = input.closest('.ajax-update').children('.estimate-tunnel__slide-right__products').children('p').children('.estimate-tunnel__slide-right__products-plurial')
          if (plurial && response < 2) {
            plurial.css('display', 'none')
          } else {
            plurial.css('display', 'inline')

          }
        }
        innerCount.text(response)
      }
    })
  })

  $('#estimateForms').on("click", ".btn-add-surface", function (e) {

    $(this).siblings('.label-text__icon').children('.input-text__icon').prop("checked", true);

    e.preventDefault()
    e.stopPropagation();

    let cloned_element = $(this).siblings('.tunnel-products__list-surface:first').clone().insertBefore($(this))
    // Extract the prefix and numeric part

    var currentValue = $(this).siblings('.tunnel-products__list-surface').length
    var text = cloned_element.children('input').data('number');
    var parts = text.match(/^(.*?_)(\d+)$/);
    var prefix = parts[1];
    var newAttributeValue = prefix + currentValue;


    cloned_element.find('.room_number').text(currentValue)
    var cloned_element_p = cloned_element.find('p')
    cloned_element_p.append('<button type="button" class="btn-remove-surface">X</button>')
    cloned_element.children('input').attr('data-number', newAttributeValue);

    addOrUpdateRoom(newAttributeValue, 6, true)

  })

  $('#estimateForms').on("click", ".btn-remove-surface", function (e) {
    $(this).closest('.tunnel-products__list-surface').remove()
  })


  function toggleFavorite(product, multiRef = null, surface = null) {
    var favoriteProducts = getFavoriteProducts();

    // Check if the product is already in the favorites
    var index = favoriteProducts.findIndex(function (item) {
      return item.product === product; // You can adjust the condition as needed
    });

    if (index !== -1) {
      // If the product is in the favorites, remove it
      favoriteProducts.splice(index, 1);
    } else {
      // If the product is not in the favorites, add it
      favoriteProducts.push({ product, multiRef, surface });
    }

    // Now, update the cookie with the updated favoriteProducts array
    setFavoriteProducts(favoriteProducts);
  }
  function setFavoriteProducts(products) {
    // Convert the array to a JSON string
    var productsJson = JSON.stringify(products);

    // Save the JSON string in a cookie
    setCookie('favoriteProducts', productsJson, 7);
  }
  // function addToFavorites(product) {
  //   var favoriteProducts = getFavoriteProducts();

  //   // Check if the product is already in the favorites
  //   var exists = favoriteProducts.some(function (item) {
  //     return item === product; // You can adjust the condition as needed
  //   });

  //   if (!exists) {
  //     favoriteProducts.push(product);
  //     setFavoriteProducts(favoriteProducts);
  //   }
  // }
  function removeFromFavorites(productId) {
    var favoriteProducts = getFavoriteProducts();


    // Find the index of the product to remove
    var index = favoriteProducts.findIndex(function (item) {

      return item.product === productId; // You can adjust the condition as needed
    });



    if (index !== -1) {
      favoriteProducts.splice(index, 1);
      setFavoriteProducts(favoriteProducts);
    }
  }


  function removeFromEstimate(productId) {
    var estimateProducts = getEstimateProducts();

    if (productId == "all") {
      // Remove everything
      estimateProducts = [];
      setFavoriteProductsInEstimate(estimateProducts);

      return; // Exit the function as we've already removed all items
    }

    // Find the index of the product to remove
    var index = estimateProducts.findIndex(function (item) {
      return item.id === productId; // You can adjust the condition as needed
    });


    if (index !== -1) {
      estimateProducts.splice(index, 1);

      setFavoriteProductsInEstimate(estimateProducts);
    }

  }


  function toggleEstimate(product) {

    var estimateProducts = getEstimateProducts();

    // Check if the product is already in the estimate
    var index = estimateProducts.findIndex(function (item) {
      return item.id === product.id; // Compare based on the "id" property
    });

    if (index !== -1) {
      // If the product is in the estimate, update it
      estimateProducts[index] = product;
    } else {
      // If the product is not in the estimate, add it
      estimateProducts.push(product);
    }

    if ($('input[name="list-whishlist"]')) {
      $('input[name="list-whishlist"]').val(JSON.stringify(estimateProducts))
    }


    // Now, update the cookie with the updated estimateProducts array
    setFavoriteProductsInEstimate(estimateProducts);
  }

  function setFavoriteProductsInEstimate(products) {
    // Convert the array to a JSON string
    var productsJson = JSON.stringify(products);

    // Save the JSON string in a cookie
    setCookie('estimateProducts', productsJson, 7);

  }

  function getEstimateProducts() {
    // Get the JSON string from the cookie
    var productsJson = getCookie('estimateProducts');

    // If the cookie exists, parse the JSON string to get the array
    if (productsJson) {
      return JSON.parse(productsJson);
    } else {
      return [];
    }
  }


  $('.btn-results__estimate').on('click', function (e) {
    e.preventDefault();

    let redirectUrl = $(this).attr('href');

    $('.listing-product__single').each(function () {
      let id = $(this).find('.listing-product__single-icon').attr('data-id')
      let surfaceValue = $(this).attr('data-surface')
      toggleEstimate({
        id: id,
        unit: surfaceValue,
        multiref: $(this).attr('data-multi'),
        libelle: $(this).attr('data-libelle')
      })
    });

    // Marquer que nous venons de sauvegarder
    sessionStorage.setItem('justSaved', 'true');
    window.location.href = redirectUrl;
  });



  $('.btn-all__favorites_click').on('click', function () {
    $(this).toggleClass('active')
    $('.listing-product__single').each(function () {
      $(this).find('.listing-product__single-icon').click()
    })
    if ($(this).hasClass('active')) {
      if (seize_data.current_language == "fr") {
        $(this).find('span').text('Supprimer ces produits de mes favoris');
      } else if (seize_data.current_language == "en") {
        $(this).find('span').text('Remove all this products from my favourite');
      }
    } else {
      if (seize_data.current_language == "fr") {
        $(this).find('span').text('Ajouter tous ces produits à mes favoris');
      } else if (seize_data.current_language == "en") {
        $(this).find('span').text('Add this products to my favourite');
      }

    }
  })

  /**
   * 
   * B A C K  T O  T O P
   * 
   */

  $(document).scroll(function () {

    if ($(document).scrollTop() >= 1000) {
      $('#back-to-top').addClass('active')
    } else if ($(document).scrollTop() >= 500) {
      $('#back-to-top').removeClass('active')
    } else {
    }
  });

  $('#back-to-top').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow', function () {

    });
  })



  let language
  let countryForm
  if (seize_data.current_language == 'fr') {
    language = "Français"
    countryForm = "France"
  } else if (seize_data.current_language == 'en') {
    language = "Anglais"
    countryForm = "France"
  } else {
    language = "Allemand"

  }
  $('.sib-LANGUE-area').val(language)

  if ($('select[name="pays"]').length > 0) {
    $('select[name="pays"]').val('France')
  }



  $('.cmplz-btn').on('click', function () {
    $('body').addClass('cmplz-added')
    //   if($('.cmplz-cookiebanner').hasClass('cmplz-dismissed')){
    //     $('body.cmplz-optin.cmplz-preferences').addClass('cmplz-preferences')
    //   }
  })

  /**
   * 
   * FILTRES INSPIRATIONS 
   * 
   */
  var valuesObject = {}; // Creating an empty object to store values

  // Function to update valuesObject
  // function updateValuesObject(val, taxonomy) {
  //   valuesObject = {}; // Clearing the previous valuesObject
  //   console.log(val)
  //   console.log(taxonomy)

  //   if (val == "all") {
  //     valuesObject[taxonomy] = '';
  //     $('ul[data-tax="' + taxonomy + '"] li').removeClass('active')
  //     $('ul[data-tax="' + taxonomy + '"] li[data-value="' + val + '"]').addClass('active')
  //   } else {
  //     $('ul[data-tax="' + taxonomy + '"] li[data-value="all"]').removeClass('active')
  //     $('ul[data-tax="' + taxonomy + '"] li[data-value="' + val + '"]').addClass('active')
  //     // Loop through each ul element with data-tax attribute
  //   }
  //   $('ul[data-tax]').each(function () {
  //     var tax = $(this).data('tax'); // Get the value of data-tax attribute
  //     var valuesArray = []; // Creating an empty array to store values for this tax

  //     // Loop through each li element inside the current ul
  //     $(this).find('li').each(function () {
  //       var value = $(this).data('value'); // Get the value of data-value attribute
  //       if ($(this).hasClass('active') && value !== 'all') {
  //         valuesArray.push(value); // Push the value into the array if it's active and not 'all'
  //       }
  //     });
  //     // Add the array of values to the valuesObject with tax as key
  //     valuesObject[tax] = valuesArray;
  //   });
  //   console.log(valuesObject)
  //   return valuesObject;
  // }

  // $('.archive-content__taxonomy-inspirations li').click(function () {
  //   let value = $(this).attr('data-value')
  //   let tax = $(this).parent('ul').data('tax')

  //   let filters = updateValuesObject(value, tax); // Update the valuesObject
  //   let seize_rest = seize_data.site_url + '/wp-json/panaget/v1'
  //   $.ajax({
  //     url: seize_rest + '/inspirationFilter',
  //     dataType: "json",
  //     type: 'POST',
  //     data: filters,
  //     success: function (response) {
  //       $('.archive-content__post .row').html(response)
  //     }
  //   })
  // });

  // Function to update valuesObject
  var valuesObject = {}; // Clearing the previous valuesObject
  var valuesText = {};
  function updateValuesObject() {

    // Loop through each dropdown
    $('.custom-dropdown_panaget').each(function () {
      var taxonomy = $(this).find('.custom-dropdown__content').data('tax'); // Get the taxonomy
      var valuesArray = []; // Creating an empty array to store values for this taxonomy
      var valuesArrayBis = []; // Creating an empty array to store values for this taxonomy

      // Loop through each checkbox inside the current dropdown
      $(this).find('.custom-dropdown__content input[type="checkbox"]').each(function () {
        if ($(this).is(':checked') && $(this).val() !== 'all') {
          valuesArray.push($(this).val()); // Push the value into the array if it's checked and not 'all'
          valuesArrayBis.push($(this).attr('data-text')); // Push the value into the array if it's checked and not 'all'
        }
      });
      // If any values are selected, add them to the selectedLabels array


      // Add the array of values to the valuesObject with taxonomy as key
      valuesObject[taxonomy] = valuesArray;
      valuesText[taxonomy] = valuesArrayBis
    });


    return valuesObject;
  }


  // Function to update dropdown toggle label
  function updateToggleLabel() {
    $('.custom-dropdown__toggle').each(function () {
      var taxonomy = $(this).data('tax'); // Get the taxonomy from data-tax attribute
      var buttonText = 'Sélectionner'; // Default button text

      // Check if the taxonomy key exists in the valuesObject
      if (valuesText.hasOwnProperty(taxonomy)) {
        var values = valuesText[taxonomy]; // Get the values associated with the taxonomy
        // If values exist and not empty, update the button text accordingly
        if (values && values.length > 0) {
          // If 'all' is in values, display "Tout voir"
          if (values.includes('all')) {
            buttonText = 'Tout voir';
          } else {
            // Otherwise, display the selected values separated by commas
            buttonText = values.join(', ');
          }
        }
      }
      // Update the button text
      $(this).text(buttonText);
    });
  }

  // Event handler for checkbox changes
  $('.custom-dropdown__content input[type="checkbox"]').change(function () {

    var filters = updateValuesObject(); // Update the valuesObject
    var seize_rest = seize_data.site_url + '/wp-json/panaget/v1';

    $.ajax({
      url: seize_rest + '/inspirationFilter',
      dataType: "json",
      type: 'POST',
      data: filters,
      success: function (response) {
        $('.archive-content__post .row').html(response);
        updateToggleLabel()
      }
    });
  });


  $('.whishlist-multi').on('change', function () {


    $('.btn-shop-multi').removeClass('active')
    $('.btn-shop-multi[data-ref="' + $(this).val() + '"]').addClass('active')
  })
  $('.select-multiref__sell').on('change', function () {
    console.log($(this).val())
    $(this).closest('.div-carac').siblings('.favorite-products__list-button').children('.btn-fill__estimate').removeClass('active')
    $('.btn-fill__estimate[data-multi="' + $(this).val() + '"]').addClass('active')
  })


  $('.search-mobile__button').on('click', function () {
    $('.header-mobile__search').toggleClass('active')
  })


  // var urlParams = new URLSearchParams(window.location.search); //get all parameters
  // var catUrl = urlParams.get('cat')
  // if(catUrl){
  //   console.log(catUrl)
  //   console.log($('.filter-btn[data-category="'+catUrl+'"'))
  //   setTimeout(() => {
  //     console.log('erzere')
  //     $('.filter-btn[data-category="'+catUrl+'"').click()
  //   }, 2000);
  // }

  $('.archive-content__post').on("click", ".archive-content__post-inner_img", function (e) {
    $('.seize-popup').addClass('active')
    $('#popup-content__img').attr('src', $(this).attr('data-ref'))
  })
  $('.inspirations-popup').on('click', ".modal-close", function () {
    $('.seize-popup').removeClass('active')
  })

  $('.custom-dropdown_panaget').on('click', function () {
    $(this).toggleClass('active')
  })


  /**
   * 
   * COMPLIANZ
   * 
   */
  let complianz = getCookie('cmplz_banner-status')
  if (complianz == "show" || complianz == undefined) {
    $('#cmplz-cookiebanner-container').removeClass('inactive')
    $('#cmplz-cookiebanner-container').addClass('show')
  } else {
    $('#cmplz-cookiebanner-container').addClass('inactive')
    $('#cmplz-cookiebanner-container').removeClass('show')
  }
  $(".cmplz-accept, .cmplz-deny, .cmplz-save-preferences").on("click", function () {
    $('#cmplz-cookiebanner-container').addClass('inactive')
    $('#cmplz-cookiebanner-container').removeClass('show')
  });

  $('.cmplz-btn.cmplz-manage-consent').on('click', function () {
    $('#cmplz-cookiebanner-container').removeClass('inactive')
    $('#cmplz-cookiebanner-container').addClass('show')
  })



  $('.post-type__filter ul li').on('click', function () {
    let filterSearch = $(this).attr('data-search')
    $('html, body').animate({
      scrollTop: ($('.col-12[data-searchpost="' + filterSearch + '"').offset().top - 100)
    }, 500);

  })



  $('.ajax_add_to_cart').on('click', function () {
    let seize_rest = seize_data.site_url + '/wp-json/panaget/v1'
    $.ajax({
      url: seize_rest + '/shopIncrement',
      type: 'POST',
      success: function (response) {

        $('.custom-cart-count').text(response);
      }
    });
  });

  $('button[name="update_cart"]').on('click', function () {
    const cartItems = document.querySelectorAll('.woocommerce-cart-form__cart-item');
    let totalQuantity = 0;
    cartItems.forEach(function (cartItem) {
      // Get the quantity input element
      const quantityInput = cartItem.querySelector('.qty');

      if (quantityInput) {
        // Get the quantity value
        const quantity = parseInt(quantityInput.value, 10);

        if (!isNaN(quantity)) {
          // Add the quantity to the total
          totalQuantity += quantity;
        }
        // Do something with the quantity
      }
    })

    $('.custom-cart-count').text(totalQuantity);
  });


  $('.product-remove .remove').on('click', function () {
    let seize_rest = seize_data.site_url + '/wp-json/panaget/v1'
    setTimeout(() => {


      $.ajax({
        url: seize_rest + '/shopIncrement',
        type: 'POST',
        success: function (response) {

          $('.custom-cart-count').text(response - 1);
        }
      });
    }, 1000);
  });

  $('#print-to-pdf').on('click', function () {
    let seize_rest = seize_data.site_url + '/wp-json/panaget/v1'
    $.ajax({
      url: seize_rest + '/generatePdf',
      type: 'POST',
      success: function (response) {


        var win = window.open(response, '_blank');
        if (win) {
          //Browser has allowed it to be opened
          win.focus();
        } else {
          //Browser has blocked it
          alert('Please allow popups for this website');
        }
      }
    })
  })




  $(document).on("click", ".estimate-tunnel_list-steps li.active button", function () {

    let step = $(this).attr('data-stepbutton')
    let currentStep = $('input[name="formid"]').val()
    let back = true

    if (step == currentStep) {
      return
    } else {
      var formData = new FormData(document.getElementById("estimateForms"));
      formData.append('back', back);
      formData.append('stepToBack', step)
      let titleStep = $('.estimate-tunnel__slide-left__title h2').text()
      $('.loader-estimate').addClass('active')

      let seize_rest = seize_data.site_url + '/wp-json/tunnel/v1'
      $.ajax({
        url: seize_rest + '/estimateForms',
        dataType: "json",
        data: formData,
        type: "POST",
        processData: false,
        contentType: false, //"application/json",
        cache: false,
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
      })
        .done(function (response) {
          if (response) {
            $.ajax({
              url: seize_rest + '/estimateTemplate',
              dataType: "json",
              data: formData,
              type: "POST",
              processData: false,
              contentType: false, //"application/json",
              cache: false,
              crossDomain: true,
              xhrFields: {
                withCredentials: true
              },
            })
              .done(function (response) {
                $('.loader-estimate').removeClass('active')

                if ($('input[name="formid"]').val() == "form-money") {
                  if (!back) {
                    marquageTunnel(formData, titleStep, response[0].form_cookie);
                    window.location.href = seize_data.site_url + '/tunnel-de-devis-reponses/';
                  } else {
                    $('#tunnel-dynamic').html(response[0].html)
                    $('.estimate-tunnel_list-steps li').removeClass('active')
                    $('.estimate-tunnel_list-steps li[data-step="' + response[0].step + '"').addClass('active')
                    $('.estimate-tunnel_list-steps li[data-step="' + response[0].step + '"').prevAll().addClass('active')
                    $("html, body").animate({ scrollTop: 0 }, "slow");

                  }
                } else {
                  if (!back) {
                    marquageTunnel(formData, titleStep)
                  }
                  $('#tunnel-dynamic').html(response[0].html)
                  $('.estimate-tunnel_list-steps li').removeClass('active')
                  $('.estimate-tunnel_list-steps li[data-step="' + response[0].step + '"').addClass('active')
                  $('.estimate-tunnel_list-steps li[data-step="' + response[0].step + '"').prevAll().addClass('active')
                  $("html, body").animate({ scrollTop: 0 }, "slow");
                }
              })

          }
        })
    }
  })


  $(document).on('click', function (event) {
    var $dropdown = $('.custom-dropdown_panaget');
    // Check if the click is outside the dropdown and its children
    if (!$dropdown.is(event.target) && $dropdown.has(event.target).length === 0) {
      $dropdown.removeClass('active');
    }
  });


  $('#bim-email').on("click", function (e) {
    e.preventDefault()
    $('.error-message').addClass('inactive')
    $(this).addClass('disabled')
    let email = $('#checkMail-input').val()
    var isValid = email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    if (!isValid) {
      $('.error-message').removeClass('inactive')
      $(this).removeClass('disabled')
      return;
    }
    let seize_rest = seize_data.site_url + '/wp-json/bim/v1/checkBimEmail'

    var route = '/checkBimEmail'
    var formData = new FormData(document.getElementById("bimCheckMail"));
    formData.append("lang", $(this).attr('data-lang'));

    $.ajax({
      url: seize_rest,
      dataType: "json",
      data: formData,
      type: "POST",
      processData: false,
      contentType: false, //"application/json",
      cache: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      success: function (response) {
        $('.conseils-services__content-inner').html(response)
        $('.form-check').html('')
      }
    })
  })
  $(document).on('click', '#bimCreateMailSubmit', function (e) {
    e.preventDefault()
    $('#bimCreateMailSubmit').addClass('disabled')

    var formData = new FormData(document.getElementById("bimCreateMail"));
    let seize_rest = seize_data.site_url + '/wp-json/bim/v1/saveBimEmail'

    $.ajax({
      url: seize_rest,
      dataType: "json",
      data: formData,
      type: "POST",
      processData: false,
      contentType: false, //"application/json",
      cache: false,
      crossDomain: true,
      xhrFields: {
        withCredentials: true
      },
      success: function (response) {
        $('.conseils-services__content-inner').html(response)
      }
    })
  })


  $('.message_alert .close').on('click', function () {
    $('.message_alert').addClass('inactive')
    setCookie('alert_message', 'true', 7);
  })


  const accordionHeaders = document.querySelectorAll('.category-accordion__header');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const target = document.querySelector(this.getAttribute('data-target'));
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      // Fermer tous les autres accordéons
      accordionHeaders.forEach(otherHeader => {
        if (otherHeader !== this) {
          const otherTarget = document.querySelector(otherHeader.getAttribute('data-target'));
          otherTarget.classList.remove('show');
          otherHeader.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle l'accordéon cliqué
      if (isExpanded) {
        target.classList.remove('show');
        this.setAttribute('aria-expanded', 'false');
      } else {
        target.classList.add('show');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });



})(jQuery);